import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {MenuItem} from "primeng/api";
import {AppointmentService} from "../../../../service/api/appointment.service";
import {AppointmentTypeService} from "../../../../service/api/appointment-type.service";
import {OverviewKpiBaseComponent} from "../../../../../../core/shared/overview/overview-kpi-base.component";
import {KpiHeaderDto} from "../../../../../../core/shared/overview/dto/kpi-header.dto";
import {ObjectRequestListGroupBy} from "../../../../../../core/shared/dto/object/request/object-request-list-group-by";
import {
    ObjectRequestListAttribute
} from "../../../../../../core/shared/dto/object/request/object-request-list-attribute";
import {
    ObjectRequestEntityProcessingTypeEnum
} from "../../../../../../core/shared/dto/object/request/object-request-entity-processing-type.enum";
import {
    DtoListAttributeRequestAggregateEnum
} from "../../../../../../core/shared/dto/enum/dto-list-attribute-request-aggregate.enum";

@Component({
    selector: 'mvs-example',
    templateUrl: 'as-kpi.component.html',
    standalone: false
})
export class AsKpiComponent extends OverviewKpiBaseComponent implements OnInit, OnChanges, OnDestroy {

    totalAppointments: number = 0;
    totalAppointmentType: number = 0;
    thisMonthAppointment: number = 0;
    thisWeekAppointment: number = 0;

    kpiHeaderDto: KpiHeaderDto[];
    items: MenuItem[] | undefined = [{label: 'AS Module'}];

    constructor(
        protected appointmentService: AppointmentService,
        protected appointmentTypeService: AppointmentTypeService) {
        super()
    }

    ngOnInit(): void {
        super.ngOnInit();
        this.initComponent();
    }

    /**
     * Initialize Component.
     */
    initComponent() {
        this.refreshComponent();
        this.getTotalAppointments();

    }

    /**
     * Refresh Component.
     */
    refreshComponent() {
        this.initialized = true;
    }


    getTotalAppointments() {

        const objectRequestList = ObjectRequestListGroupBy.create(
            false,
            [],
            [],
            ['status'],
            [new ObjectRequestListAttribute('status', "Anzahl", DtoListAttributeRequestAggregateEnum.count)],
            ObjectRequestEntityProcessingTypeEnum.regular
        );

        this.appointmentService.groupBy(objectRequestList).subscribe(res => {
            this.totalAppointments = res.entries.reduce((acc, item) => acc + item['status_count'], 0);
            this.getTotalAppointmentType();
        }, error => {
            this.getTotalAppointmentType();
        });
    }

    getTotalAppointmentType() {
        const objectRequestList = ObjectRequestListGroupBy.create(
            false,
            [],
            [],
            ['locationInternal'],
            [new ObjectRequestListAttribute('locationInternal', "Anzahl", DtoListAttributeRequestAggregateEnum.count)],
            ObjectRequestEntityProcessingTypeEnum.regular
        );

        this.appointmentTypeService.groupBy(objectRequestList).subscribe(res => {
            this.totalAppointmentType = res.entries.reduce((acc, item) => acc + item['locationInternal_count'], 0);
            this.getThisMonthAppointment();
        }, error => {
            this.getThisMonthAppointment();
        });
    }

    getThisMonthAppointment() {
        const objectRequestList = this.getThisMonthRequest('status');
        this.appointmentService.groupBy(objectRequestList).subscribe(res => {
            this.thisMonthAppointment = res.entries.reduce((acc, item) => acc + item['status_count'], 0);
            this.getThisWeekAppointment();
        }, error => {
            this.getThisWeekAppointment();
        });
    }

    getThisWeekAppointment() {
        const objectRequestList = this.getThisWeekRequest('status');
        this.appointmentService.groupBy(objectRequestList).subscribe(res => {
            this.thisWeekAppointment = res.entries.reduce((acc, item) => acc + item['status_count'], 0);
            this.initKpiHeaderDto();
        }, error => {
            this.initKpiHeaderDto();
        });
    }


    initKpiHeaderDto() {

        this.kpiHeaderDto = [
            {
                label: 'Total Appointments', value: [this.totalAppointments],
            },
            {
                label: 'Total Appointments Type', value: [this.totalAppointmentType],
            },
            {
                label: 'This Month Appointments', value: [this.thisMonthAppointment],
            },
            {
                label: 'This Week Appointments', value: [this.thisWeekAppointment],
            },
        ]
    }

    /**
     * Process changes within Binding.
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {

        if (!this.initialized) {
            return;
        }

        if (changes["id"]) {
            this.refreshComponent();
        }
    }

    /**
     * Destroy component.
     */
    ngOnDestroy(): void {

    }
}
